var map = {
	"./": [
		315,
		9
	],
	"./ExternalGames": [
		1129,
		9,
		119
	],
	"./ExternalGames.dictionary": [
		316,
		3
	],
	"./ExternalGames.dictionary.json": [
		316,
		3
	],
	"./ExternalGames.explanation": [
		1131,
		9,
		120
	],
	"./ExternalGames.explanation.ts": [
		1131,
		9,
		120
	],
	"./ExternalGames.module.scss": [
		1130,
		9,
		278
	],
	"./ExternalGames.tsx": [
		1129,
		9,
		119
	],
	"./ExternalGamesDeferred": [
		365,
		9
	],
	"./ExternalGamesDeferred.tsx": [
		365,
		9
	],
	"./components/GameTile": [
		967,
		9,
		50
	],
	"./components/GameTile/": [
		967,
		9,
		50
	],
	"./components/GameTile/GameTile.module.scss": [
		1078,
		9,
		303
	],
	"./components/GameTile/index": [
		967,
		9,
		50
	],
	"./components/GameTile/index.tsx": [
		967,
		9,
		50
	],
	"./index": [
		315,
		9
	],
	"./index.tsx": [
		315,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1266;
module.exports = webpackAsyncContext;